import service from '@/api/service/service';
import qs from "qs";

// 信息回显
export function info_view(params = {}) {
  return service({
    url: "/api/main/stu_singn_info_view.json",
    method: 'get',
    params: params,
  });
}

// 保存学员信息
export function saveInfo(data = {}) {
  return service({
    url: "/api/main/teacher_sign_info.json",
    method: 'post',
    data: qs.stringify(data),
  });
}